/* unplugin-vue-components disabled */import { render } from "./error-modal.vue?vue&type=template&id=eed846b0&scoped=true"
import script from "./error-modal.vue?vue&type=script&lang=js"
export * from "./error-modal.vue?vue&type=script&lang=js"

import "./error-modal.vue?vue&type=style&index=0&id=eed846b0&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed846b0"],['__file',"src/controls/error-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eed846b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eed846b0', __exports__)) {
    api.reload('eed846b0', __exports__)
  }
  
  module.hot.accept("./error-modal.vue?vue&type=template&id=eed846b0&scoped=true", () => {
    api.rerender('eed846b0', render)
  })

}


export default __exports__